import React from 'react'
import "../CSS/Template/About.css"
import Arindam from "../Images/Arindam.jpg"
import email from "../Images/Favicons/gmail.png"
import { Typewriter } from "react-simple-typewriter"
import { Helmet } from 'react-helmet'
import FooTer from "./footer"
import { useHistory } from 'react-router-dom';


export default function About(props) {
  let history = useHistory()
  let text = Typewriter({
    words: ["Let Me Tell About Me..."],
    loop: 0,
    typeSpeed: 70,
    deleteSpeed: 50,
    delaySpeed: 1000,
    cursor: true,
    cursorStyle: "⌛"
  })
  
  let showCv = ()=>{
    history.push("/About/MyCV")
  }
  return (
    <>
      <Helmet>
        <title>Code Arindam | About</title>
      </Helmet>
      <div id="about">
        <div class="sharethis-sticky-share-buttons" ></div>
        <div className="images">
          {props.setProgress(0)}
          <img src={Arindam} alt="loading" />
          <div className="simpleTxt">
            <span style={{ fontWeight: "bold", color: "yellow", fontSize: "2.5rem" }}>E</span><span className='simple'>at😋</span><br />
            <span style={{ fontWeight: "bold", color: "black", fontSize: "2.5rem" }}>S</span><span className='simple'>leep😴</span><br />
            <span style={{ fontWeight: "bold", color: "green", fontSize: "2.5rem" }}>C</span><span className='simple'>ode🧑‍💻</span><br />
          </div>
        </div>
        <div className="documentCon">
          {props.setProgress(25)}
          <h1><span>{text}</span></h1>
          <p style={{ fontWeight: "bold" }}><span style={{ fontSize: "3rem", color: "red" }}>M</span><span style={{ color: "white" }}>yself</span> <span style={{ color: "white" }}>Arindam...</span></p>
          <p className='dFirst' style={{ color: "white" }}>"Humans Could Be lie But Code Never be". My Occupacion is to create website also proggramer.</p>
          <div className="pathContact">
            {props.setProgress(50)}
            <div className="address">
              <p id='addressP' style={{ color: "black", fontWeight: "bold", textAlign: "center", marginTop: "4rem" }}>Address🏠</p>
              <iframe title='myAddress' src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3479.770218150993!2d87.74763761791979!3d22.176176565531478!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3a02c6e287d0b2ff%3A0xa182ae8dc61f111d!2sGoramahal%2C%20West%20Bengal!5e1!3m2!1sen!2sin!4v1659645447432!5m2!1sen!2sin" width="300" height="200" style={{ border: 0, margin: "0px 10px", alignSelf: "center" }} loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
            </div>
            <div className="emailMe">
              <p style={{ textAlign: "center", fontWeight: "bold" }}>Email Me</p>
              <a style={{ alignSelf: "center" }} href="mailto:marindam2017@gmail.com"><img src={email} alt="loading" /></a>
              <p style={{ fontWeight: "bold", textAlign: "center" }}>(Click On The Mail Logo)</p>
            </div>
          </div>
          <div className="yt">
            {props.setProgress(100)}
            <span style={{ fontSize: "3rem", color: "red" }}>Y</span><span style={{ color: "white" }}>ouTube</span> <span style={{ color: "white" }}>Is Also My Fevorite Part Of My Life.</span>
            <span style={{ color: "white" }}> Subscribe My Channel -</span> <span><a target="_blank" rel="noreferrer" style={{ textDecoration: "none", color: "red", fontSize: "1.5rem", fontWeight: "bold", fontFamily: "system-ui" }} href="https://www.youtube.com/channel/UClkomV-p7Ul_d4-Ye5uOvYg">Code Arindam</a></span>
          </div>
          <div className="cv">
            <p className="cvText">
              HERE IS MY CV OR  RESUME CLICK ON THE BUTTON TO SEE AND DOWNLOAD
            </p>
            <button id='cvBtn' onClick={showCv}>Show CV</button>
          </div>
        </div>
      </div>
      <FooTer />
    </>
  )
}
